module.exports = __webpack_public_path__ + "img/Aguacate-temporada.822400e4.jpg";